import { Edit, Save } from '@mui/icons-material';
import {
  Box,
  Card,
  IconButton,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import { FormTemplateType } from 'api/models';
import { mutation } from 'operations';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { FormTemplateEditorMode } from 'routes/FormTemplateEditor/FormTemplateEditor';
import { GeneralIds, ModelTypes } from 'types/types';

interface ReportTemplateEditorCardProps {
  reportTemplateType?: FormTemplateType;
}

export function ReportTemplateEditorCard({
  reportTemplateType,
}: ReportTemplateEditorCardProps) {
  const [isEditing, setIsEditing] = useState(false);
  const [formName, setFormName] = useState(reportTemplateType?.name);
  const { t } = useTranslation();
  const { projectId, formTemplateTypeId } = useParams<GeneralIds>();

  useEffect(() => {
    if (reportTemplateType) {
      setFormName(reportTemplateType.name);
      setIsEditing(false);
    }
  }, [reportTemplateType]);

  const onEdit = () => {
    if (isEditing) {
      mutation<FormTemplateType>({
        type: ModelTypes.formTemplateType,
        body: {
          id: formTemplateTypeId ?? '',
          name: formName ?? '',
          type: FormTemplateEditorMode.report,
        },
        ids: {
          id: formTemplateTypeId,
          projectId,
        },
      });
    }

    setIsEditing(!isEditing);
  };

  return (
    <Card
      elevation={1}
      sx={{
        mt: 1,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        border: theme => `1px solid ${theme.palette.divider}`,
        p: 1,
      }}
    >
      {isEditing ? (
        <Box display={'flex'} flexDirection={'row'} width={'100%'}>
          <TextField
            label={t('reports.name')}
            type="text"
            fullWidth
            value={formName}
            onChange={e => setFormName(e.target.value)}
            sx={{ mr: 1 }}
          />
        </Box>
      ) : (
        <Typography variant="h6" fontWeight={'bold'} m={1}>
          {formName}
        </Typography>
      )}

      <IconButton size="small" onClick={onEdit} sx={{ ml: 1 }}>
        {isEditing ? (
          <Tooltip title={t('general.save')}>
            <Save fontSize="small" />
          </Tooltip>
        ) : (
          <Tooltip title={t('general.edit')}>
            <Edit fontSize="small" />
          </Tooltip>
        )}
      </IconButton>
    </Card>
  );
}
